import packageInfo from '../../../package.json';
import { PLUGIN_NAME } from './constants';

const { version } = packageInfo;

async function load(app) {
  app.events.on('plugin:ecommerce:event:*', event => {
    import(
      /* webpackChunkName: "kpEcommerceEventHandler" */ './utils/ecommerce-event-handler'
    ).then(({ default: ecommerceEventHandler }) => ecommerceEventHandler(event, app));
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
